<template>
    <td-dialog :title="$t(title)" :before-close="logTypeDialogClose" :visible.sync="dialogTypeVisible" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formLogInfo" :label-width="formLabelWidth" ref="formLogInfo" :rules="rules">
            <el-form-item :label="$t('common.NUMBER')" prop="sId" v-if="false">
                <el-col :span="16">
                    <td-input-number v-model="formLogInfo.sId" :disabled="autoIdDisabled" :controlsPosition="controlsPosition"></td-input-number>
                </el-col>
                <el-col :span="2">
                    <td-checkbox v-model="sIdChecked" v-if="isAddData" ref="sIdChecked" @change="autoCreateId" name="common.AUTO_CREATE"></td-checkbox>
                </el-col>
            </el-form-item>
            <el-form-item :label="$t('common.NAME')" prop="sCaption">
                <td-input v-model="formLogInfo.sCaption" :maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.LABEL')" prop="sPermission">
                <td-input v-model="formLogInfo.sPermission" :maxlength="50"></td-input>
            </el-form-item>
            <el-form-item v-if="!isAddData">
                <div style="width:200px;">{{ $t('log.OPERATION_PERMISSION_STR_TIP') }}</div>
            </el-form-item>
            <el-form-item :label="$t('common.OPERATION_LEVEL')" prop="sOperationLevelId">
                <td-select v-model="formLogInfo.sOperationLevelId" :options="options"></td-select>
            </el-form-item>
            <el-form-item :label="$t('role.I_ALLOW_FINETUNE')" prop="iAllowFinetune">
                <td-switch v-model="iAllowFinetune" activeText="" inactiveText=""></td-switch>
            </el-form-item>
            <el-form-item :label="$t('common.DESCRIPTION')" prop="sDescription">
                <td-input type="textarea" :rows="2" style="width:200px;" v-model="formLogInfo.sDescription" :maxlength="100"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formLogInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="logTypeDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import typeApi from '../assets/api.js';
import levelApi from '../../logLevelManager/assets/api.js';
export default {
    props: ['title', 'dialogTypeVisible', 'editItem', 'isAddData', 'sSysFlg', 'iAllowFinetune'],
    created() {
        if (this.iAllowFinetune) {
            this.iAllowFinetune = true;
        } else {
            this.iAllowFinetune = false;
        }
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        }
        // eslint-disable-next-line no-unused-vars
        let a = this.iAllowFinetune;
    },
    // 定义变量
    data() {
        let validateCaption = (rule, value, callback) => {
            let param = {
                sCaption: value,
                sSysFlg: this.sSysFlg
            };
            let _this = this;
            typeApi.checkOperationType(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('type/checkOperationType', response.data.statusMessage);
                    return;
                }
                if (response.data.content) {
                    let check = response.data.content.some(function(item) {
                        if (item.sId != _this.formLogInfo.sId) {
                            return true;
                        }
                    });
                    if ((!this.isAddData && check) || this.isAddData) {
                        return callback(this.$t('error.ERROR_OPE_TYPE_REPEAT'));
                    }
                }
                return callback();
            });
        };
        let validateAuthStr = (rule, value, callback) => {
            let param = {
                sPermission: value,
                sSysFlg: this.sSysFlg
            };
            let _this = this;
            typeApi.checkOperationType(JSON.stringify(param), response => {
                if (response.data.statusCode !== _this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('type/checkOperationType', response.data.statusMessage);
                    return;
                }
                if (response.data.content) {
                    let check = response.data.content.some(function(item) {
                        if (item.sId != _this.formLogInfo.sId) {
                            return true;
                        }
                    });
                    if ((!_this.isAddData && check) || _this.isAddData) {
                        return callback(_this.$t('error.ERROR_OPE_TYPE_PERMISSION_STR_REPEAT'));
                    }
                }
                return callback();
            });
        };
        return {
            // 表单信息
            formLogInfo: {
                // iAllowFinetune: false,
                sId: '',
                sCaption: '',
                sDescription: '',
                sPermission: '',
                iAllowFinetune: '',
                sOperationLevelId: ''
            },
            controlsPosition: 'right',
            // mq类型数组
            options: [],
            sIdChecked: true,
            autoIdDisabled: true,
            formLabelWidth: '100px',
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                sCaption: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') },
                    { validator: validateCaption, trigger: 'blur' }
                ],
                sOperationLevelId: [{ required: true, message: this.$t('error.ERROR_SELECT_LEVEL_NULL'), trigger: 'change' }],
                sPermission: [
                    { required: true, message: this.$t('error.ERROR_LABEL_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { pattern: this.$regex.AUTH_STR, message: this.$t('error.ERROR_OPETATION_TYPE_STR_ILLEGAL') },
                    { validator: validateAuthStr, trigger: 'blur' }
                ],
                sDescription: [{ min: 1, max: 100, message: this.$t('error.ERROR_DESCRIPTION_MAX_LENGTH'), trigger: 'blur' }]
            }
        };
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        let param = {
            sSysFlg: this.sSysFlg,
            isPage: false
        };
        levelApi.queryOperationLevel(JSON.stringify(param), response => {
            if (response.status !== this.$common.login.RESPONSE_STATUS) {
                this.$log.error('logTypeManager/queryOperationLevel', response);
                return;
            }
            if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('logTypeManager/queryOperationLevel', response.data.statusMessage);
                return;
            }
            let levelList = response.data.content;
            this.options = [];
            if (levelList) {
                for (let i = 0; i < levelList.length; i++) {
                    let temValue = levelList[i];
                    let item = {
                        value: temValue.sId,
                        label: temValue.sCaption
                    };
                    this.options.push(item);
                }
            }
        });
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            debugger;
            this.formLogInfo.sId = this.editItem.sId;
            this.formLogInfo.sCaption = this.editItem.sCaption;
            this.formLogInfo.sDescription = this.editItem.sDescribe;
            this.formLogInfo.sPermission = this.editItem.sPermission;
            this.formLogInfo.sOperationLevelId = this.editItem.sOperationLevelId;
            this.formLogInfo.iAllowFinetune = this.iAllowFinetune;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let content = {
                        sId: this.formLogInfo.sId,
                        sCaption: this.formLogInfo.sCaption,
                        sDescribe: this.formLogInfo.sDescription,
                        sPermission: this.formLogInfo.sPermission,
                        sSysFlg: this.sSysFlg,
                        iAllowFinetune: this.iAllowFinetune ? 1 : 0,
                        sOperationLevelId: this.formLogInfo.sOperationLevelId
                    };
                    if (this.isAddData) {
                        typeApi.addOperationType(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogTypeInfo/addOperationType', response);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.logReLevelDialogSave();
                        });
                    } else {
                        typeApi.updateOperationType(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogTypeInfo/updateOperationType', response);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.logReLevelDialogSave();
                        });
                    }
                }
            });
        },

        // 自动生成id
        autoCreateId() {
            if (!this.isAddData) {
                this.autoIdDisabled = true;
                return;
            }
            if (this.autoIdDisabled) {
                this.autoIdDisabled = false;
            } else {
                this.formLogInfo.sId = null;
                this.autoIdDisabled = true;
            }
        },

        // 关闭窗口之前需要调用的方法
        logTypeDialogClose() {
            this.$emit('logTypeDialogClose');
        },
        // 添加和修改关闭窗口之前需要调用的方法
        logReLevelDialogSave() {
            this.$emit('submit');
            this.$emit('logTypeDialogClose');
            this.$refs['formLogInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
